import { z } from "zod";
import { zSyllableSegmentationData } from "@/lib/api-client/zod.gen";
import { PROD } from "@/lib/data/words";
import { createExerciseStore } from "./create-exercise-store";

export const prodStore = createExerciseStore(
  "prod",
  PROD,
  z.object({
    recording_b64: z.string(),
    apiResponse: z.object({
      highest: z.number(),
      syllable_segmentation: zSyllableSegmentationData.optional(),
    }),
    correct: z.boolean(),
    timestamp: z.number(),
    hintVisible: z.boolean(),
  }),
  (attempts) => {
    const firstCorrect = attempts.findIndex((a) => a.correct);
    if (firstCorrect === -1) return attempts.length >= 3 ? 0 : "IN_PROGRESS";
    return [100, 50, 25][firstCorrect] ?? 0;
  },
);
